import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";

import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  CircularProgress,
  ToggleButtonGroup,
  Grid,
  ToggleButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import API from "../utils/API";
import { useEffect, useState } from "react";
import db from "../db/db";
import { BUILD_NUMBER } from "../build";
import { Store } from "./../utils/Store";
import { AgentUtils } from "./../utils/AgentUtils";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://saleolabs.com/">
        saleolabs
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

export default function Login(props) {
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const translate = t;
  const [errorMessage, setErrorMessage] = useState("");

  const [shopCode, setShopCode] = useState("");

  const [shopCodeError, setShopCodeError] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [language, setLanguage] = useState("en");

  const handleLnChange = (
    event: React.MouseEvent<HTMLElement>,
    nextView: string
  ) => {
    setLanguage(nextView);
    i18n.changeLanguage(nextView);
    localStorage.setItem("w_lang", nextView);
  };

  useEffect(() => {
    if (localStorage.getItem("w_shopCode")) {
      setShopCode(localStorage.getItem("w_shopCode"));
    }
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // eslint-disable-next-line no-console
    console.log({
      email: data.get("email"),
      password: data.get("password"),
    });

    checkLogin(new FormData(event.currentTarget));
  };

  async function checkLogin(form) {
    setErrorMessage("");
    try {
      if (!validate(form)) {
        return;
      }
      setLoading(true);
      console.log("Real Loggin");
      const response = await fetch(
        (await AgentUtils.getBaseUrl()) + "/auth/v1/users/signin",
        {
          method: "post",
          body: JSON.stringify({
            username: form.get("userName"),
            password: form.get("password"),
            shopCode: form.get("shopCode"),
          }),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        const json = await response.json();

        if (
          localStorage.getItem("w_shopCode") &&
          localStorage.getItem("w_shopCode") != shopCode
        ) {
          for (var i = 0; i < localStorage.length; i++) {
            console.log("Remove Local storage ", localStorage.key(i));
            localStorage.removeItem(localStorage.key(i));
          }
          let syncableData = [
            "sync_head",
            "role",
            "sync_meta",
            "sale",
            "info",
            "product",
            "category",
            "config",
            "setting",
            "tax",
            "vendor",
            "promotion",
            "customer",
            "terminal",
            "file",
            "productImport",
            "inventoryAdjBulkImport",
            "service",
            "export_profile_config",
            "sale_return",
            "sale_order",
            "sale_hold",
            "sale_return_hold",
            "service_hold",
            "floor",
            "sale_order_hold",
            "fxrate",
          ];

          for (let i = 0; i < syncableData.length; i++) {
            let table = syncableData[i];
            console.log("Removing", table);
            try {
              await db.table(table).clear();
            } catch (err) {
              console.log(err);
            }
          }
        }

        localStorage.setItem("w_accessToken", json.accessToken);
        localStorage.setItem("w_refreshToken", json.refreshToken);
        localStorage.setItem("w_shopCode", form.get("shopCode"));

        API.defaults.headers.common = {
          Authorization: `Bearer ${json.refreshToken}`,
          baseURL: await AgentUtils.getBaseUrl(),
        };
        let jwt = Store.parseJwt(json.accessToken);
        await API.post("/api/v1/ejectuser", {
          accessTokenHash: Store.hashCode(json.accessToken),
          userName: jwt.sub,
        });

        props.setUserName(json.name);

        let result = await API.get("/auth/v1/shops/info");
        localStorage.setItem("storeName", result.data.name);

        props.onLogin();
      } else if (response.status === 500) {
        setErrorMessage(translate("Login failed. Can not contact Server..."));
        setLoading(false);
      } else {
        setErrorMessage(translate("Invalid Credentials..."));
        setLoading(false);
      }
    } catch (e) {
      setErrorMessage(translate("Invalid Credentials..."));
      setLoading(false);
      console.log(e);
    }
  }

  function validate(form) {
    let flag = true;
    setShopCodeError("");
    setUserNameError("");
    setPasswordError("");
    if (!form.get("shopCode") || form.get("shopCode") == "") {
      setShopCodeError(translate("Shop Code Required"));
      flag = false;
    }
    if (!form.get("userName") || form.get("userName") == "") {
      setUserNameError(translate("User Name Required"));
      flag = false;
    }
    if (!form.get("password") || form.get("password") == "") {
      setPasswordError(translate("Password Required"));
      flag = false;
    }
    return flag;
  }

  return (
    <Grid container style={{ height: "100vh" }}>
      <Grid
        item
        xs={7}
        style={{
          backgroundColor: "#080C55",
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 1000'%3E%3Cg %3E%3Ccircle fill='%23080C55' cx='50' cy='0' r='50'/%3E%3Cg fill='%23031760' %3E%3Ccircle cx='0' cy='50' r='50'/%3E%3Ccircle cx='100' cy='50' r='50'/%3E%3C/g%3E%3Ccircle fill='%2300216a' cx='50' cy='100' r='50'/%3E%3Cg fill='%23002b75' %3E%3Ccircle cx='0' cy='150' r='50'/%3E%3Ccircle cx='100' cy='150' r='50'/%3E%3C/g%3E%3Ccircle fill='%2300357f' cx='50' cy='200' r='50'/%3E%3Cg fill='%23003f89' %3E%3Ccircle cx='0' cy='250' r='50'/%3E%3Ccircle cx='100' cy='250' r='50'/%3E%3C/g%3E%3Ccircle fill='%23004993' cx='50' cy='300' r='50'/%3E%3Cg fill='%2300539c' %3E%3Ccircle cx='0' cy='350' r='50'/%3E%3Ccircle cx='100' cy='350' r='50'/%3E%3C/g%3E%3Ccircle fill='%23005da5' cx='50' cy='400' r='50'/%3E%3Cg fill='%230067ae' %3E%3Ccircle cx='0' cy='450' r='50'/%3E%3Ccircle cx='100' cy='450' r='50'/%3E%3C/g%3E%3Ccircle fill='%230072b6' cx='50' cy='500' r='50'/%3E%3Cg fill='%23007cbf' %3E%3Ccircle cx='0' cy='550' r='50'/%3E%3Ccircle cx='100' cy='550' r='50'/%3E%3C/g%3E%3Ccircle fill='%230086c7' cx='50' cy='600' r='50'/%3E%3Cg fill='%230091cf' %3E%3Ccircle cx='0' cy='650' r='50'/%3E%3Ccircle cx='100' cy='650' r='50'/%3E%3C/g%3E%3Ccircle fill='%23009cd6' cx='50' cy='700' r='50'/%3E%3Cg fill='%2300a6dd' %3E%3Ccircle cx='0' cy='750' r='50'/%3E%3Ccircle cx='100' cy='750' r='50'/%3E%3C/g%3E%3Ccircle fill='%2304b1e4' cx='50' cy='800' r='50'/%3E%3Cg fill='%2321bceb' %3E%3Ccircle cx='0' cy='850' r='50'/%3E%3Ccircle cx='100' cy='850' r='50'/%3E%3C/g%3E%3Ccircle fill='%2333c6f2' cx='50' cy='900' r='50'/%3E%3Cg fill='%2343d1f9' %3E%3Ccircle cx='0' cy='950' r='50'/%3E%3Ccircle cx='100' cy='950' r='50'/%3E%3C/g%3E%3Ccircle fill='%2352DCFF' cx='50' cy='1000' r='50'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundAttachment: "fixed",
          backgroundSize: "contain",
        }}
      >
        <Grid container>
          <Grid item xs={12} style={{ marginTop: 10, marginLeft: 20 }}>
            <Typography variant="h3" component="div" color="#eeeeee">
              eSale POS
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ marginLeft: 20 }}>
            <Typography variant="h6" component="div" color="#dddddd">
              Retail Cloud
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ marginLeft: 20 }}>
            <Typography
              variant="overline"
              display="block"
              gutterBottom
              color="#cccccc"
            >
              Version : 3.0.{BUILD_NUMBER}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={5}>
        <ThemeProvider theme={theme}>
          <Grid conatainer>
            <Grid item xs={12}>
              <div
                style={{ textAlign: "right", marginTop: 10, marginRight: 10 }}
              >
                <ToggleButtonGroup
                  value={language}
                  exclusive
                  onChange={handleLnChange}
                >
                  <ToggleButton value="en" aria-label="list">
                    English
                  </ToggleButton>
                  <ToggleButton value="ar" aria-label="module">
                    عربي
                  </ToggleButton>{" "}
                </ToggleButtonGroup>
              </div>
            </Grid>
            <Grid item xs={12}></Grid>
          </Grid>

          <Container component="main">
            <CssBaseline />
            <Box
              sx={{
                paddingTop: "100px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                {translate("Sign In")}
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label={translate("Shop Code")}
                  name="shopCode"
                  autoComplete="shoCOde"
                  autoFocus
                  value={shopCode}
                  onChange={(e) => setShopCode(e.target.value)}
                />
                <Typography variant="caption">{shopCodeError}</Typography>

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="userName"
                  label={translate("User Name")}
                  name="userName"
                  autoComplete="userName"
                  autoFocus
                />
                <Typography variant="caption">{userNameError}</Typography>

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label={translate("Password")}
                  type="password"
                  id="password"
                  autoComplete="current-password"
                />
                <Typography variant="caption">{passwordError}</Typography>

                <Typography variant="caption">{errorMessage}</Typography>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={loading}
                >
                  {loading && <CircularProgress size={20} />}
                  {translate("Sign In")}
                </Button>
              </Box>
            </Box>
            <Copyright sx={{ mt: 8, mb: 4 }} />
          </Container>
        </ThemeProvider>
      </Grid>
    </Grid>
  );
}
